"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = exports.Dropdown = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react2 = require("../hooks/react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormControl = _interopRequireDefault(require("../FormControl"));

var _FormHelperText = _interopRequireDefault(require("../FormHelperText"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _useFormState2 = _interopRequireDefault(require("../hooks/useFormState"));

var _core = require("@material-ui/core");

var styles = function styles(theme) {
  return {
    input: {
      '&:focus': {
        backgroundColor: 'transparent'
      }
    },
    icon: {
      marginRight: theme.spacing(1)
    },
    emptyTextUtil: {
      '&::before': {
        content: '""',
        display: 'inline-block'
      }
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);
var STANDARD = 'standard';
var OUTLINED = 'outlined';
var FILLED = 'filled';

var isOutlined = function isOutlined(variant) {
  return variant === OUTLINED;
};

var Dropdown = function Dropdown(_ref) {
  var value = _ref.value,
      list = _ref.list,
      label = _ref.label,
      dataQa = _ref.dataQa,
      variant = _ref.variant,
      name = _ref.name,
      error = _ref.error,
      onChange = _ref.onChange,
      helperText = _ref.helperText,
      disabled = _ref.disabled,
      inputProps = _ref.inputProps;
  var classes = useStyles();
  var inputLabel = (0, _react2.useRef)(null);

  var _useState = (0, _react2.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      labelWidth = _useState2[0],
      setLabelWidth = _useState2[1];

  (0, _react2.useEffect)(function () {
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []);
  var selectInput = {
    input: /*#__PURE__*/_react["default"].createElement(_core.OutlinedInput, {
      labelWidth: labelWidth,
      name: label,
      id: "outlined-age-simple-".concat(dataQa)
    })
  };
  var selectProps = (0, _extends2["default"])({}, isOutlined(variant) ? selectInput : {}); //If list has no items to display then add disabled "No options" item

  var shouldDisableMenuItem = list.length === 0;
  var internalList = shouldDisableMenuItem ? [['No options', 'No options']] : list;
  return /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
    variant: variant,
    error: error,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(_core.InputLabel, {
    ref: inputLabel,
    variant: variant,
    htmlFor: "outlined-age-simple-".concat(dataQa)
  }, label), /*#__PURE__*/_react["default"].createElement(_core.Select, (0, _extends2["default"])({
    name: name,
    disabled: disabled,
    value: value,
    onChange: onChange
  }, selectProps, {
    inputProps: {
      className: (0, _classnames["default"])(classes.input, inputProps)
    },
    "data-qa": dataQa,
    classes: {
      icon: classes.icon
    }
  }), internalList.map(function (el) {
    return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      key: el[0],
      value: el[0],
      disabled: shouldDisableMenuItem
    }, el[1]);
  })), /*#__PURE__*/_react["default"].createElement(_FormHelperText["default"], null, helperText || /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.emptyTextUtil
  })));
};

exports.Dropdown = Dropdown;
Dropdown.propTypes = {
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  onChange: _propTypes["default"].func.isRequired,
  list: _propTypes["default"].array.isRequired,
  label: _propTypes["default"].string.isRequired,
  dataQa: _propTypes["default"].string.isRequired,
  error: _propTypes["default"].bool,
  helperText: _propTypes["default"].string,
  variant: _propTypes["default"].oneOf([STANDARD, OUTLINED, FILLED]),
  disabled: _propTypes["default"].bool,
  inputProps: _propTypes["default"].object
};
Dropdown.defaultProps = {
  value: '',
  list: [],
  label: '',
  variant: OUTLINED
};
/**
 * For some reason the value has to be passed into the Dropdown component
 * to get the animated label.
 */

var stateDropdown = function stateDropdown(props) {
  var _useFormState = (0, _useFormState2["default"])(props),
      name = _useFormState.name,
      value = _useFormState.value,
      onChange = _useFormState.onChange,
      onBlur = _useFormState.onBlur,
      error = _useFormState.error;

  return /*#__PURE__*/_react["default"].createElement(Dropdown, (0, _extends2["default"])({}, props, {
    name: name,
    value: value || '',
    onChange: onChange,
    onBlur: onBlur,
    error: error
  }));
};

var _default = stateDropdown;
exports["default"] = _default;